<!-- components/LanguageSelector.vue -->
<template>
    <section class="flex justify-center items-center">
        <div class="relative w-full h-full max-w-[380px] max-h-[240px]">
            <!-- Main Card -->
            <div
                class="relative w-full h-full rounded-2xl border border-[var(--background-btn)] bg-[var(--background-primary)] p-4 shadow-md">
                <h2 class="text-lg font-semibold text-foreground mb-3">
                    Select Preferred Language
                </h2>

                <div class="grid grid-cols-2 gap-4">
                    <!-- English -->
                    <div class="flex items-center gap-3 px-2 py-4 bg-[#FAFAFA0A] rounded-md cursor-pointer"
                        @click="selected = 'en'">
                        <img src="https://flagcdn.com/w40/us.png" alt="English" class="w-7 h-7 rounded-full" />
                        <p class="text-base font-medium text-foreground flex-1">English</p>
                        <div
                            class="w-4 h-4 rounded-full border border-[var(--background-btn)] flex items-center justify-center">
                            <div v-if="selected === 'en'" class="w-2 h-2 bg-foreground rounded-full"></div>
                        </div>
                    </div>

                    <!-- Español -->
                    <div class="flex items-center gap-3 px-2 py-4 bg-[#FAFAFA0A] rounded-md cursor-pointer"
                        @click="selected = 'es'">
                        <img src="https://flagcdn.com/w40/es.png" alt="Español" class="w-7 h-7 rounded-full" />
                        <p class="text-base font-medium text-foreground flex-1">Español</p>
                        <div
                            class="w-4 h-4 rounded-full border border-[var(--background-btn)] flex items-center justify-center">
                            <div v-if="selected === 'es'" class="w-2 h-2 bg-foreground rounded-full"></div>
                        </div>
                    </div>

                    <!-- Français -->
                    <div class="flex items-center gap-3 px-2 py-4 bg-[#FAFAFA0A] rounded-md cursor-pointer"
                        @click="selected = 'fr'">
                        <img src="https://flagcdn.com/w40/fr.png" alt="Français" class="w-7 h-7 rounded-full" />
                        <p class="text-base font-medium text-foreground flex-1">Français</p>
                        <div
                            class="w-4 h-4 rounded-full border border-[var(--background-btn)] flex items-center justify-center">
                            <div v-if="selected === 'fr'" class="w-2 h-2 bg-foreground rounded-full"></div>
                        </div>
                    </div>

                    <!-- Deutsch -->
                    <div class="flex items-center gap-3 px-2 py-4 bg-[#FAFAFA0A] rounded-md cursor-pointer"
                        @click="selected = 'de'">
                        <img src="https://flagcdn.com/w40/de.png" alt="Deutsch" class="w-7 h-7 rounded-full" />
                        <p class="text-base font-medium text-foreground flex-1">Deutsch</p>
                        <div
                            class="w-4 h-4 rounded-full border border-[var(--background-btn)] flex items-center justify-center">
                            <div v-if="selected === 'de'" class="w-2 h-2 bg-foreground rounded-full"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
const selected = ref("en");
</script>
